import { render, staticRenderFns } from "./LessonsPdf.vue?vue&type=template&id=815d7e9c&scoped=true"
import script from "./LessonsPdf.vue?vue&type=script&lang=js"
export * from "./LessonsPdf.vue?vue&type=script&lang=js"
import style0 from "./LessonsPdf.vue?vue&type=style&index=0&id=815d7e9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "815d7e9c",
  null
  
)

export default component.exports